import s from './Engraving.module.scss'

import { AnimatePresence, motion } from 'framer-motion'
import { ChangeEvent, useEffect, useRef, useState } from 'react'
import { CanvasTexture, Mesh, MeshStandardMaterial, Object3D } from 'three'

export const Engraving = ({ model }: { model: Object3D | undefined }): JSX.Element => {
  const fonts = ['Montserrat', 'Amazone BT', 'Rockwell']

  const canvasRef = useRef<HTMLCanvasElement>(null)

  const [text, setText] = useState('')
  const [font, setFont] = useState(fonts[0])

  const canvasWidth = 380
  const canvasHeight = 420
  const fontSize = 48

  const canvas = canvasRef.current
  const context = canvas !== null ? canvas.getContext('2d') : null

  function createTexture(text: string, font: string) {
    if (!canvas || !context) {
      return
    }

    context.clearRect(0, 0, canvasWidth, canvas.height)
    context.fillStyle = 'rgba(255, 255, 255, 0)'
    context.fillRect(0, 0, canvasWidth, canvas.height)

    context.textAlign = 'center'
    context.textBaseline = 'middle'
    context.fillStyle = '#323232'
    context.font = `${fontSize}px ${font}`
    context.fillText(text, canvasWidth * 0.5, canvasHeight * 0.5)

    const texture = new CanvasTexture(canvas)
    texture.needsUpdate = true

    return texture
  }

  function attachToModel(mesh: Mesh, texture: CanvasTexture | undefined) {
    if (!texture) {
      return
    }

    ;(mesh.material as MeshStandardMaterial).needsUpdate = true
    ;(mesh.material as MeshStandardMaterial).opacity = 1.0
    ;(mesh.material as MeshStandardMaterial).map = texture

    texture.dispose()
  }

  function handleChangeText(event: ChangeEvent<HTMLInputElement>) {
    setText(event.target.value)
  }

  function handleChangeFont(event: ChangeEvent<HTMLInputElement>) {
    setFont(event.target.value)
  }

  useEffect(() => {
    if (!model) {
      return
    }

    const texture = createTexture(text, font)

    for (const mesh of model.children[0].children) {
      if (mesh.name === '#grav') {
        attachToModel(mesh as Mesh, texture)
      }
    }
  }, [text, font])

  return (
    <>
      <AnimatePresence>
        <motion.div
          initial={{ bottom: -60, left: '50%' }}
          exit={{ bottom: -60, left: '50%' }}
          transition={{ duration: 0.6 }}
          className={s.Engraving}
        >
          <input
            type="text"
            autoComplete="off"
            className={s.engraving_text}
            maxLength={20}
            value={text}
            onChange={handleChangeText}
          />
          <div className={s.engraving_radio_wrap}>
            {fonts.map((fontFamily, key) => {
              return (
                <label key={key} className={s.engraving_radio}>
                  <input
                    type="radio"
                    value={fontFamily}
                    checked={fontFamily === font}
                    onChange={handleChangeFont}
                  />
                  <span style={{ fontFamily }}>{'Ab12'}</span>
                </label>
              )
            })}
          </div>
        </motion.div>
      </AnimatePresence>
      <canvas
        ref={canvasRef}
        width={canvasWidth}
        height={canvasHeight}
        style={{ display: 'none' }}
      />
    </>
  )
}
